import React, { createContext, useState } from 'react'

export const AnnouncementContext = createContext({
  announcementHeight: 0,
  heightChangeHandler: () => {},
})

const AnnouncementContextProvider = (props) => {
  const [announcementHeight, setAnnouncementHeight] = useState(0)

  const heightChangeHandler = (height) => {
    setAnnouncementHeight(height)
    document.documentElement.style.setProperty('--announcement-height', height + 'px')
  }

  return (
    <AnnouncementContext.Provider
      value={{
        announcementHeight: announcementHeight,
        heightChangeHandler: heightChangeHandler,
      }}
    >
      {props.children}
    </AnnouncementContext.Provider>
  )
}

export default AnnouncementContextProvider